import { RadioButton } from '@ver-uds/uswds-react';
import classNames from 'classnames';
import React, { forwardRef, ReactNode, ComponentPropsWithoutRef } from 'react';
import Header, { HeaderProps } from './Header';

export interface RadioHeaderProps extends Omit<HeaderProps, 'children'>, ComponentPropsWithoutRef<typeof RadioButton> {
  id: string;
  children?: ReactNode;
}

const RadioHeader = forwardRef<HTMLInputElement, RadioHeaderProps>(
  ({ children, id, label, className, ...radioProps }: RadioHeaderProps, ref): JSX.Element => {
    return (
      <Header id={id} className={classNames('ver-accordion-card__header--radio', className)}>
        <RadioButton
          id={`${id}--radio`}
          label={label}
          ref={ref}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...radioProps}
        />
        {children}
      </Header>
    );
  },
);

export default RadioHeader;
